// extracted by mini-css-extract-plugin
export default {"header_wrapper":"Header_header_wrapper__Q7wQ8","header_btnBox":"Header_header_btnBox__gSwG9"};